/* eslint-disable */
export function setBaseURL() {
   axios.defaults.baseURL = process.env.VUE_APP_API_URL
}

export function setIntercept(store, router) {
   axios.interceptors.response.use(null, (error) => {
      if (error.response.status == 401) {
         store.commit('logout');
         router.push('/login');
      }

      return Promise.reject(error);
   })
}



// WEBPACK FOOTER //
// ./src/services/api.js